<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">资产分类</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <div></div>
        <!-- <el-input
          clearable
          placeholder="请输入名称或编号"
          size="small"
          v-model="params['search']"
          style="width:300px;"
        >
          <i
            slot="suffix"
            class="el-icon-search inputIcon "
            @click.stop="tableSearch"
          ></i>
        </el-input> -->
        <el-button type="submit" @click="add_area({}, '0')">新增</el-button>
      </div>
      <!-- :tableData="tableData" url="/pc/classify/page" -->
      <x-table
      :key="tableKey"
        :tableData="tableData"
        row-key="id"
        :tree-props="{ hasChildren: 'hasChildren', children: 'children' }"
        lazy
        :load="load"
        ><el-table-column
          v-for="item in columnArr"
          :key="item.id"
          :label="item.label"
          :prop="item.model"
        >
          <template slot-scope="scope">
            <span v-if="item.model == 'deprType'">{{
              deprType_fulter(scope.row[item.model])
            }}</span>
            <span v-else-if="item.model == 'deadline'">{{
              scope.row[item.model]
                ? scope.row[item.model] + deadline_fulter(scope.row["deprType"])
                : ""
            }}</span>
            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="addColor"
              @click="add_area({}, scope.row.id, true)"
              >新增下级</el-button
            >
            <el-button type="text" class="addColor" @click="add_area(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              class="deleteColor"
              @click="
                $axiosDelete(
                  '/pc/classify/del',
                  { id: scope.row.id },
                  tableSearch,
                  '',
                  true
                )
              "
              >删除</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableKey: 0,
      tableData: [],
      params: {},
      columnArr: [
        {
          label: "分类名称",
          model: "cName",
        },
        {
          label: "分类编号",
          model: "cCode",
        },
        {
          label: "折旧配置",
          model: "deprType",
        },
        {
          label: "预计可用",
          model: "deadline",
        },
        {
          label: "残值率(%)",
          model: "salvage",
        },
        {
          label: "月工作量",
          model: "monthCount",
        },
        {
          label: "操作人",
          model: "createName",
        },

        {
          label: "操作时间",
          model: "createTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    /*  */
    init() {
      this.tableSearch();
    },
    load(tree, treeNode, resolve) {
      console.log(tree, treeNode, resolve);
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId:tree.id },
        },
        (data) => {
          if (data.data.length) {
            let result = data.data.map((item) => {
              item.hasChildren = true;
              return item;
            });
            resolve(result);
          } else {
            resolve([]);
          }
        }
      );
      console.log(tree, treeNode, resolve);
    },
    deadline_fulter(data) {
      let a = "";
      switch (data) {
        case null:
          a = "";
          break;
        case "straight":
          a = "月";
          break;
        case "decrease":
          a = "年";

          break;
        case "yeartotal":
          a = "年";

          break;
        case "workload":
          a = "次";

          break;
        default:
          a = "";
      }
      return a;
    },

    deprType_fulter(data) {
      let a = "";
      switch (data) {
        case null:
          a = "无";
          break;
        case "straight":
          a = "年限平均法";

          break;
        case "workload":
          a = "工作量法";

          break;
        case "decrease":
          a = "双倍余额递减法";

          break;
        case "yeartotal":
          a = "年数总和法";

          break;
        default:
          a = "无";
      }
      return a;
    },
    tableSearch() {
      this.tableKey++
      this.$requestAxios(
        {
          url: "/pc/classify/page",
          data: { pId: "0" },
        },
        (data) => {
          
          if (data.data && data.data.length) {
            let result = data.data.map((item) => {
              item.hasChildren = true;
              return item;
            });
            console.log(result);

            this.tableData = result;
          } else {
            this.tableData = [];
          }
        }
      );
    },
    add_area(row, parentId, isChildren) {
      this.$createDialog(this, {
        dialogConfig: {
          title: JSON.stringify(row) !== "{}" ? "分类编辑" : "分类新增",
          width: "360px",
        },
        namespace: "sys_add_classify",
        whetherDestruction: true,

        assemblyConfig: {
          row: row,
          parentId,
          isChildren: isChildren ? isChildren : false,
          callBack: this.tableSearch,
        },
      });
    },
  },
};
</script>
<style scoped></style>
